import { ProgramSource, prependDefines } from "./ShaderUtil";
import frameEldritchFragShader from "./frame-eldritch.frag.glsl";
import frameEldritchVertShader from "./frame-eldritch.vert.glsl";
import frameFogFragShader from "./frame-fog.frag.glsl";
import frameFogVertShader from "./frame-fog.vert.glsl";
import frameFxaaFragShader from "./frame-fxaa.frag.glsl";
import frameFxaaVertShader from "./frame-fxaa.vert.glsl";
import frameGrimdarkFragShader from "./frame-grimdark.frag.glsl";
import frameGrimdarkVertShader from "./frame-grimdark.vert.glsl";
import frameParchmentFragShader from "./frame-parchment.frag.glsl";
import frameParchmentVertShader from "./frame-parchment.vert.glsl";
import frameFragShader from "./frame.frag.glsl";
import frameVertShader from "./frame.vert.glsl";
import mainFragShader from "./main.frag.glsl";
import mainVertShader from "./main.vert.glsl";
import npcVertShader from "./npc.vert.glsl";

export function createProgram(
    vertShader: string,
    fragShader: string,
    hasMultiDraw: boolean,
    discardAlpha: boolean,
): ProgramSource {
    const defines: string[] = [];
    if (hasMultiDraw) {
        defines.push("MULTI_DRAW");
    }
    if (discardAlpha) {
        defines.push("DISCARD_ALPHA");
    }
    return [prependDefines(vertShader, defines), prependDefines(fragShader, defines)];
}

export function createMainProgram(hasMultiDraw: boolean, discardAlpha: boolean): ProgramSource {
    return createProgram(mainVertShader, mainFragShader, hasMultiDraw, discardAlpha);
}

export function createNpcProgram(hasMultiDraw: boolean, discardAlpha: boolean): ProgramSource {
    return createProgram(npcVertShader, mainFragShader, hasMultiDraw, discardAlpha);
}

export const FRAME_PROGRAM = [frameVertShader, frameFragShader];
export const FRAME_FXAA_PROGRAM = [frameFxaaVertShader, frameFxaaFragShader];
export const FRAME_PARCHMENT_PROGRAM = [frameParchmentVertShader, frameParchmentFragShader];
export const FRAME_ELDRITCH_PROGRAM = [frameEldritchVertShader, frameEldritchFragShader];
export const FRAME_GRIMDARK_PROGRAM = [frameGrimdarkVertShader, frameGrimdarkFragShader];
export const FRAME_FOG_PROGRAM = [frameFogVertShader, frameFogFragShader];
